module.exports = __webpack_public_path__ + "img/lightning-icon-white.61b29692.svg";